import _slicedToArray from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _asyncToGenerator from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getApplication, NotificareApplicationUnavailableError, getOptions, NotificareNotConfiguredError, logInternal, isReady, broadcastComponentEvent, fetchNotification, logNotificationOpen, fetchApplication, NotificareNotReadyError, registerPushDevice, getCurrentDevice, NotificareDeviceUnavailableError, deleteDevice, registerTemporaryDevice, isConfigured, getCloudApiEnvironment, Component, registerComponent, NotificareServiceUnavailableError } from '@notificare/web-core';
import { Logger } from '@notificare/web-logger';
import { __rest } from 'tslib';
import { updateCloudDevice } from '@notificare/web-cloud-api';
import { createRoot, createBackdrop, createModal, createModalContent, createModalFooter, createDestructiveButton, createPrimaryButton } from '@notificare/web-ui';
var logger = new Logger('notificare/push');

function requestSafariPermission(websiteUrl, websiteIdentifier, queryParameters) {
  return new Promise(function (resolve, reject) {
    if (!window.safari) {
      reject(new Error('Safari not available in window.'));
      return;
    }

    try {
      window.safari.pushNotification.requestPermission(websiteUrl, websiteIdentifier, queryParameters, resolve);
    } catch (e) {
      reject(e);
    }
  });
}

function hasSafariPushSupport() {
  var _a;

  return ((_a = window.safari) === null || _a === void 0 ? void 0 : _a.pushNotification) != null;
}

function enableSafariPushNotifications() {
  return _enableSafariPushNotifications.apply(this, arguments);
}

function _enableSafariPushNotifications() {
  _enableSafariPushNotifications = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var _a, _b, _c, application, options, uid, currentPermission, currentDeviceToken, permission, deviceToken;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            application = getApplication();

            if (application) {
              _context6.next = 3;
              break;
            }

            throw new NotificareApplicationUnavailableError();

          case 3:
            options = getOptions();

            if (options) {
              _context6.next = 6;
              break;
            }

            throw new NotificareNotConfiguredError();

          case 6:
            uid = (_c = (_b = (_a = application.websitePushConfig) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.subject) === null || _c === void 0 ? void 0 : _c.UID;

            if (uid) {
              _context6.next = 9;
              break;
            }

            throw new Error('Missing Safari Website Push configuration. Please check your Website Push configurations in our dashboard before proceeding.');

          case 9:
            if (window.safari) {
              _context6.next = 11;
              break;
            }

            throw new Error('Your browser does not support Safari Website Push.');

          case 11:
            currentPermission = window.safari.pushNotification.permission(uid);
            currentDeviceToken = checkSafariRemoteNotificationPermission(currentPermission);

            if (!currentDeviceToken) {
              _context6.next = 15;
              break;
            }

            return _context6.abrupt("return", currentDeviceToken);

          case 15:
            _context6.next = 17;
            return requestSafariPermission(options.services.websitePushHost, uid, {
              applicationKey: options.applicationKey
            });

          case 17:
            permission = _context6.sent;
            deviceToken = checkSafariRemoteNotificationPermission(permission);

            if (deviceToken) {
              _context6.next = 21;
              break;
            }

            throw new Error('Safari device token unavailable upon requesting permission.');

          case 21:
            return _context6.abrupt("return", deviceToken);

          case 22:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _enableSafariPushNotifications.apply(this, arguments);
}

function checkSafariRemoteNotificationPermission(_ref) {
  var permission = _ref.permission,
      deviceToken = _ref.deviceToken;

  switch (permission) {
    case 'default':
      return undefined;

    case 'granted':
      if (!deviceToken) throw new Error('Safari device token unavailable.');
      return deviceToken;

    case 'denied':
      throw new Error('Safari Website Push permission denied.');

    default:
      throw new Error("Unhandled safari permission (".concat(permission, ")."));
  }
}

var notificationSettingsChangedCallback;
var notificationReceivedCallback;
var notificationOpenedCallback;
var notificationActionOpenedCallback;
var systemNotificationReceivedCallback;
var unknownNotificationReceivedCallback;

function onNotificationSettingsChanged(callback) {
  notificationSettingsChangedCallback = callback;
  return {
    remove: function remove() {
      notificationSettingsChangedCallback = undefined;
    }
  };
}

function onNotificationReceived(callback) {
  notificationReceivedCallback = callback;
  return {
    remove: function remove() {
      notificationReceivedCallback = undefined;
    }
  };
}

function onNotificationOpened(callback) {
  notificationOpenedCallback = callback;
  return {
    remove: function remove() {
      notificationOpenedCallback = undefined;
    }
  };
}

function onNotificationActionOpened(callback) {
  notificationActionOpenedCallback = callback;
  return {
    remove: function remove() {
      notificationActionOpenedCallback = undefined;
    }
  };
}

function onSystemNotificationReceived(callback) {
  systemNotificationReceivedCallback = callback;
  return {
    remove: function remove() {
      systemNotificationReceivedCallback = undefined;
    }
  };
}

function onUnknownNotificationReceived(callback) {
  unknownNotificationReceivedCallback = callback;
  return {
    remove: function remove() {
      unknownNotificationReceivedCallback = undefined;
    }
  };
}

function notifyNotificationSettingsChanged(allowedUI) {
  var callback = notificationSettingsChangedCallback;

  if (!callback) {
    logger.debug("The 'notification_settings_changed' handler is not configured.");
    return;
  }

  callback(allowedUI);
}

function notifyNotificationReceived(notification, deliveryMechanism) {
  var callback = notificationReceivedCallback;

  if (!callback) {
    logger.warning("The 'notification_received' handler is not configured.");
    return;
  }

  callback(notification, deliveryMechanism);
}

function notifyNotificationOpened(notification) {
  var callback = notificationOpenedCallback;

  if (!callback) {
    logger.warning("The 'notification_opened' handler is not configured.");
    return;
  }

  callback(notification);
}

function notifyNotificationActionOpened(notification, action) {
  var callback = notificationActionOpenedCallback;

  if (!callback) {
    logger.warning("The 'notification_action_opened' handler is not configured.");
    return;
  }

  callback(notification, action);
}

function notifySystemNotificationReceived(notification) {
  var callback = systemNotificationReceivedCallback;

  if (!callback) {
    logger.warning("The 'system_notification_received' handler is not configured.");
    return;
  }

  callback(notification);
}

function notifyUnknownNotificationReceived(notification) {
  var callback = unknownNotificationReceivedCallback;

  if (!callback) {
    logger.warning("The 'unknown_notification_received' handler is not configured.");
    return;
  }

  callback(notification);
}

function logPushRegistration() {
  return _logPushRegistration.apply(this, arguments);
}

function _logPushRegistration() {
  _logPushRegistration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return logInternal({
              type: 're.notifica.event.push.Registration'
            });

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _logPushRegistration.apply(this, arguments);
}

function logNotificationReceived(_x) {
  return _logNotificationReceived.apply(this, arguments);
}

function _logNotificationReceived() {
  _logNotificationReceived = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return logInternal({
              type: 're.notifica.event.notification.Receive',
              notificationId: id
            });

          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _logNotificationReceived.apply(this, arguments);
}

function logNotificationInfluenced(_x2) {
  return _logNotificationInfluenced.apply(this, arguments);
}

function _logNotificationInfluenced() {
  _logNotificationInfluenced = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(id) {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return logInternal({
              type: 're.notifica.event.notification.Influenced',
              notificationId: id
            });

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _logNotificationInfluenced.apply(this, arguments);
}

function base64UrlToUint8Array(base64UrlData) {
  var padding = '='.repeat((4 - base64UrlData.length % 4) % 4);
  var base64 = (base64UrlData + padding).replace(/-/g, '+').replace(/_/g, '/');
  var rawData = atob(base64);
  var buffer = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; i += 1) {
    buffer[i] = rawData.charCodeAt(i);
  }

  return buffer;
}

function arrayBufferToBase64Url(buffer) {
  return uint8ArrayToBase64Url(new Uint8Array(buffer));
}

function arrayBufferToBase64(buffer) {
  return uint8ArrayToBase64(new Uint8Array(buffer));
}

function uint8ArrayToBase64Url(bytes) {
  return uint8ArrayToBase64(bytes).replace(/\//g, '_').replace(/\+/g, '-').replace(/=+$/g, '');
}

function uint8ArrayToBase64(bytes) {
  var rawData = '';

  for (var i = 0; i < bytes.byteLength; i += 1) {
    rawData += String.fromCharCode(bytes[i]);
  }

  return btoa(rawData);
}

function sleep(milliseconds) {
  return new Promise(function (resolve) {
    setTimeout(resolve, milliseconds);
  });
}

function isChromeBrowser() {
  var expression = /Chrome/i;
  return expression.test(navigator.userAgent);
}

function isSafariBrowser() {
  var expression = /Safari/i;
  return expression.test(navigator.userAgent) && !isChromeBrowser();
}

function isSafariDesktopBrowser() {
  var expression = /Mac/i;
  return expression.test(navigator.userAgent) && isSafariBrowser();
}

function isStandaloneMode() {
  return navigator.standalone !== undefined ? navigator.standalone : window.matchMedia('(display-mode: standalone)').matches;
}

function base64Encode(data) {
  return window.btoa(data);
}

function base64Decode(data) {
  return window.atob(data);
}

function parseWorkerConfiguration(encoded) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var config;

  try {
    var decoded = base64Decode(encoded);
    config = JSON.parse(decoded);
  } catch (e) {
    return undefined;
  }

  var _config = config,
      applicationKey = _config.applicationKey;
  if (!applicationKey) return undefined;
  var _config2 = config,
      applicationSecret = _config2.applicationSecret;
  if (!applicationSecret) return undefined;
  return {
    applicationKey: applicationKey,
    applicationSecret: applicationSecret,
    useTestEnvironment: config.useTestEnvironment,
    standalone: config.standalone
  };
}

function encodeWorkerConfiguration(config) {
  return base64Encode(JSON.stringify(config));
}

var SUBSCRIPTION_EXPIRATION_TIME_LEEWAY_MILLIS = 432000000;

function registerServiceWorker(_x3) {
  return _registerServiceWorker.apply(this, arguments);
}

function _registerServiceWorker() {
  _registerServiceWorker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(options) {
    var _a, workerPathname, activeRegistration, registrationOptions, url;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            workerPathname = (_a = options.serviceWorker) !== null && _a !== void 0 ? _a : '/sw.js';

            if (hasSupportedProtocol(options.applicationHost)) {
              _context10.next = 3;
              break;
            }

            throw new Error('Service workers are only available over HTTPS or localhost.');

          case 3:
            _context10.next = 5;
            return getActiveWorkerRegistration(workerPathname);

          case 5:
            activeRegistration = _context10.sent;

            if (!activeRegistration) {
              _context10.next = 9;
              break;
            }

            logger.debug('Using previously registered service worker.');
            return _context10.abrupt("return", activeRegistration);

          case 9:
            logger.debug('Registering new service worker.');

            if (options.serviceWorkerScope) {
              registrationOptions = {
                scope: options.serviceWorkerScope
              };
            }

            url = getConfiguredWorkerUrl(workerPathname);
            _context10.next = 14;
            return navigator.serviceWorker.register(url, registrationOptions);

          case 14:
            return _context10.abrupt("return", navigator.serviceWorker.ready);

          case 15:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _registerServiceWorker.apply(this, arguments);
}

function createWebPushSubscription(_x4, _x5) {
  return _createWebPushSubscription.apply(this, arguments);
}

function _createWebPushSubscription() {
  _createWebPushSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(registration, vapidPublicKey) {
    var currentSubscription, currentApplicationServerKey;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return registration.pushManager.getSubscription();

          case 2:
            currentSubscription = _context11.sent;

            if (!currentSubscription) {
              _context11.next = 18;
              break;
            }

            logger.debug('Validating the current push subscription.');
            currentApplicationServerKey = currentSubscription.options.applicationServerKey && arrayBufferToBase64Url(currentSubscription.options.applicationServerKey);

            if (!(currentApplicationServerKey !== vapidPublicKey)) {
              _context11.next = 13;
              break;
            }

            logger.warning('The VAPID public keys changed.');
            logger.debug('Removing stable push subscription.');
            _context11.next = 11;
            return currentSubscription.unsubscribe();

          case 11:
            logger.debug('Subscribing for push notifications again.');
            return _context11.abrupt("return", subscribe(registration, vapidPublicKey));

          case 13:
            if (!subscriptionAboutToExpire(currentSubscription)) {
              _context11.next = 18;
              break;
            }

            logger.debug('Renewing existing push subscription.');
            _context11.next = 17;
            return currentSubscription.unsubscribe();

          case 17:
            return _context11.abrupt("return", subscribe(registration, vapidPublicKey));

          case 18:
            logger.debug('Subscribing for push notifications.');
            return _context11.abrupt("return", subscribe(registration, vapidPublicKey));

          case 20:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _createWebPushSubscription.apply(this, arguments);
}

function hasSupportedProtocol(applicationHost) {
  return applicationHost.includes('localhost') || applicationHost.startsWith('https');
}

function getActiveWorkerRegistration(_x6) {
  return _getActiveWorkerRegistration.apply(this, arguments);
}

function _getActiveWorkerRegistration() {
  _getActiveWorkerRegistration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(workerPathname) {
    var registrations;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return navigator.serviceWorker.getRegistrations();

          case 2:
            registrations = _context12.sent;
            return _context12.abrupt("return", registrations.find(function (r) {
              return isValidWorkerRegistration(r, workerPathname);
            }));

          case 4:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _getActiveWorkerRegistration.apply(this, arguments);
}

function isValidWorkerRegistration(registration, workerPathname) {
  var worker = registration.active;
  if (!worker) return true;
  var workerUrl = new URL(worker.scriptURL);
  if (workerUrl.pathname !== workerPathname) return false;
  var workerEncodedConfig = workerUrl.searchParams.get('notificareConfig');
  if (!workerEncodedConfig) return false;
  var workerConfig = parseWorkerConfiguration(workerEncodedConfig);
  if (!workerConfig) return false;
  var expectedConfig = getWorkerConfiguration();
  return areSameWorkerConfiguration(workerConfig, expectedConfig);
}

function getConfiguredWorkerUrl(location) {
  var config = getWorkerConfiguration();
  var encoded = encodeWorkerConfiguration(config);
  var url = new URL(location, window.location.origin);
  url.searchParams.set('notificareConfig', encoded);
  return url.href.replace(window.location.origin, '');
}

function getWorkerConfiguration() {
  var options = getOptions();
  if (!options) throw new NotificareNotConfiguredError();
  return {
    applicationKey: options.applicationKey,
    applicationSecret: options.applicationSecret,
    useTestEnvironment: options.useTestEnvironment ? true : undefined,
    standalone: isStandaloneMode() ? true : undefined
  };
}

function areSameWorkerConfiguration(config, expectedConfig) {
  return expectedConfig.applicationKey === config.applicationKey && expectedConfig.applicationSecret === config.applicationSecret && expectedConfig.useTestEnvironment === config.useTestEnvironment && expectedConfig.standalone === config.standalone;
}

function subscriptionAboutToExpire(subscription) {
  var expirationTime = subscription.expirationTime;
  if (!expirationTime) return false;
  return Date.now() > expirationTime - SUBSCRIPTION_EXPIRATION_TIME_LEEWAY_MILLIS;
}

function subscribe(_x7, _x8) {
  return _subscribe.apply(this, arguments);
}

function _subscribe() {
  _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(registration, vapidPublicKey) {
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: base64UrlToUint8Array(vapidPublicKey)
            }));

          case 1:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _subscribe.apply(this, arguments);
}

function hasWebPushSupport() {
  // The navigator.standalone check ensures that iOS Safari with WebPush
  // support is running in 'Add To Home Screen' mode.
  return 'serviceWorker' in navigator && 'PushManager' in window && 'showNotification' in ServiceWorkerRegistration.prototype && (navigator.standalone === undefined || isStandaloneMode() || isSafariDesktopBrowser());
}

function enableWebPushNotifications(_x9, _x10) {
  return _enableWebPushNotifications.apply(this, arguments);
}

function _enableWebPushNotifications() {
  _enableWebPushNotifications = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(application, options) {
    var _a, _b, publicKey, registration, subscription;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            publicKey = (_b = (_a = application.websitePushConfig) === null || _a === void 0 ? void 0 : _a.vapid) === null || _b === void 0 ? void 0 : _b.publicKey;

            if (publicKey) {
              _context14.next = 3;
              break;
            }

            throw new Error('Missing VAPID configuration. Please check your Website Push configurations in our dashboard before proceeding.');

          case 3:
            _context14.next = 5;
            return registerServiceWorker(options);

          case 5:
            registration = _context14.sent;
            _context14.next = 8;
            return createWebPushSubscription(registration, publicKey);

          case 8:
            subscription = _context14.sent;
            return _context14.abrupt("return", getPushTokenFromPushSubscription(subscription));

          case 10:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _enableWebPushNotifications.apply(this, arguments);
}

function disableWebPushNotifications() {
  return _disableWebPushNotifications.apply(this, arguments);
}

function _disableWebPushNotifications() {
  _disableWebPushNotifications = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
    var registration, subscription;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return navigator.serviceWorker.ready;

          case 2:
            registration = _context15.sent;
            _context15.next = 5;
            return registration.pushManager.getSubscription();

          case 5:
            subscription = _context15.sent;

            if (subscription) {
              _context15.next = 9;
              break;
            }

            logger.warning('No push subscription when disabling web push.');
            return _context15.abrupt("return");

          case 9:
            _context15.next = 11;
            return subscription.unsubscribe();

          case 11:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _disableWebPushNotifications.apply(this, arguments);
}

function postMessageToServiceWorker(_x11) {
  return _postMessageToServiceWorker.apply(this, arguments);
}

function _postMessageToServiceWorker() {
  _postMessageToServiceWorker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(message) {
    var registration;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return navigator.serviceWorker.ready;

          case 2:
            registration = _context16.sent;

            if (registration.active) {
              _context16.next = 5;
              break;
            }

            throw new Error('Service worker is not active.');

          case 5:
            registration.active.postMessage(message);

          case 6:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _postMessageToServiceWorker.apply(this, arguments);
}

function handleServiceWorkerMessage(_x12) {
  return _handleServiceWorkerMessage.apply(this, arguments);
}

function _handleServiceWorkerMessage() {
  _handleServiceWorkerMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(event) {
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            if (!isReady()) {
              _context17.next = 9;
              break;
            }

            _context17.prev = 1;
            _context17.next = 4;
            return postMessageToServiceWorker({
              action: 're.notifica.ready'
            });

          case 4:
            _context17.next = 9;
            break;

          case 6:
            _context17.prev = 6;
            _context17.t0 = _context17["catch"](1);
            logger.warning('Failed to send a message to the service worker.', _context17.t0);

          case 9:
            if (event.data) {
              _context17.next = 11;
              break;
            }

            return _context17.abrupt("return");

          case 11:
            _context17.t1 = event.data.cmd;
            _context17.next = _context17.t1 === 're.notifica.push.sw.notification_received' ? 14 : _context17.t1 === 're.notifica.push.sw.notification_clicked' ? 17 : _context17.t1 === 're.notifica.push.sw.notification_reply' ? 20 : _context17.t1 === 're.notifica.push.sw.system_notification_received' ? 23 : _context17.t1 === 're.notifica.push.sw.unknown_notification_received' ? 26 : _context17.t1 === 're.notifica.push.sw.update_inbox' ? 29 : 32;
            break;

          case 14:
            _context17.next = 16;
            return handleServiceWorkerNotificationReceived(event);

          case 16:
            return _context17.abrupt("break", 33);

          case 17:
            _context17.next = 19;
            return handleServiceWorkerNotificationClicked(event);

          case 19:
            return _context17.abrupt("break", 33);

          case 20:
            _context17.next = 22;
            return handleServiceWorkerNotificationReply(event);

          case 22:
            return _context17.abrupt("break", 33);

          case 23:
            _context17.next = 25;
            return handleServiceWorkerSystemNotificationReceived(event);

          case 25:
            return _context17.abrupt("break", 33);

          case 26:
            _context17.next = 28;
            return handleServiceWorkerUnknownNotificationReceived(event);

          case 28:
            return _context17.abrupt("break", 33);

          case 29:
            _context17.next = 31;
            return handleServiceWorkerUpdateInbox();

          case 31:
            return _context17.abrupt("break", 33);

          case 32:
            logger.warning('Unknown service worker message event: ', event);

          case 33:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[1, 6]]);
  }));
  return _handleServiceWorkerMessage.apply(this, arguments);
}

function getPushTokenFromPushSubscription(subscription) {
  var rawKey = subscription.getKey('p256dh');
  var rawAuthSecret = subscription.getKey('auth');
  var keys;

  if (rawKey && rawAuthSecret) {
    keys = {
      p256dh: arrayBufferToBase64(rawKey),
      auth: arrayBufferToBase64(rawAuthSecret)
    };
  }

  return {
    endpoint: subscription.endpoint,
    keys: keys
  };
}

function handleServiceWorkerNotificationReceived(_x13) {
  return _handleServiceWorkerNotificationReceived.apply(this, arguments);
}

function _handleServiceWorkerNotificationReceived() {
  _handleServiceWorkerNotificationReceived = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(event) {
    var notification, deliveryMechanism;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            broadcastComponentEvent('notification_received');

            if (!event.data.content) {
              _context18.next = 6;
              break;
            }

            // Standard format
            notification = event.data.content.notification;
            deliveryMechanism = event.data.content.message.push ? 'standard' : 'silent';
            _context18.next = 12;
            break;

          case 6:
            _context18.next = 8;
            return logNotificationReceived(event.data.message.notificationId);

          case 8:
            _context18.next = 10;
            return fetchNotification(event.data.message.id);

          case 10:
            notification = _context18.sent;
            deliveryMechanism = event.data.message.push ? 'standard' : 'silent';

          case 12:
            notifyNotificationReceived(notification, deliveryMechanism);

          case 13:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _handleServiceWorkerNotificationReceived.apply(this, arguments);
}

function handleServiceWorkerNotificationClicked(_x14) {
  return _handleServiceWorkerNotificationClicked.apply(this, arguments);
}

function _handleServiceWorkerNotificationClicked() {
  _handleServiceWorkerNotificationClicked = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(event) {
    var _event$data$content, _notification, action, notificationId, notification;

    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            if (!event.data.content) {
              _context19.next = 5;
              break;
            }

            // Notify the inbox to update itself.
            broadcastComponentEvent('notification_opened');
            _event$data$content = event.data.content, _notification = _event$data$content.notification, action = _event$data$content.action;

            if (action) {
              notifyNotificationActionOpened(_notification, action);
            } else {
              notifyNotificationOpened(_notification);
            }

            return _context19.abrupt("return");

          case 5:
            notificationId = event.data.notification.id; // Log the notification open event.

            _context19.next = 8;
            return logNotificationOpen(notificationId);

          case 8:
            _context19.next = 10;
            return logNotificationInfluenced(notificationId);

          case 10:
            // Notify the inbox to update itself.
            broadcastComponentEvent('notification_opened');
            _context19.next = 13;
            return fetchNotification(notificationId);

          case 13:
            notification = _context19.sent;
            notifyNotificationOpened(notification);

          case 15:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _handleServiceWorkerNotificationClicked.apply(this, arguments);
}

function handleServiceWorkerNotificationReply(_x15) {
  return _handleServiceWorkerNotificationReply.apply(this, arguments);
}

function _handleServiceWorkerNotificationReply() {
  _handleServiceWorkerNotificationReply = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(event) {
    var notification, action;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return logNotificationOpen(event.data.notification.notificationId);

          case 2:
            _context20.next = 4;
            return logNotificationInfluenced(event.data.notification.notificationId);

          case 4:
            _context20.next = 6;
            return fetchNotification(event.data.notification.id);

          case 6:
            notification = _context20.sent;
            action = notification.actions.find(function (element) {
              return element.id === event.data.action;
            });

            if (action) {
              _context20.next = 11;
              break;
            }

            logger.warning('Cannot find the action clicked to process the event.');
            return _context20.abrupt("return");

          case 11:
            notifyNotificationActionOpened(notification, action);

          case 12:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _handleServiceWorkerNotificationReply.apply(this, arguments);
}

function handleServiceWorkerSystemNotificationReceived(_x16) {
  return _handleServiceWorkerSystemNotificationReceived.apply(this, arguments);
}

function _handleServiceWorkerSystemNotificationReceived() {
  _handleServiceWorkerSystemNotificationReceived = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(event) {
    var notification, id, notificationId, notificationType, push, system, systemType, urlFormatString, xSender, application, icon, extra;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            notification = event.data.message;

            if (!notification.notificationType.startsWith('re.notifica')) {
              _context21.next = 12;
              break;
            }

            logger.info("Processing system notification: ".concat(notification.notificationType));
            _context21.t0 = notification.notificationType;
            _context21.next = _context21.t0 === 're.notifica.notification.system.Application' ? 6 : 9;
            break;

          case 6:
            _context21.next = 8;
            return fetchApplication();

          case 8:
            return _context21.abrupt("break", 10);

          case 9:
            logger.warning("Unhandled system notification: ".concat(notification.notificationType));

          case 10:
            _context21.next = 15;
            break;

          case 12:
            logger.info("Processing custom system notification.");
            id = notification.id, notificationId = notification.notificationId, notificationType = notification.notificationType, push = notification.push, system = notification.system, systemType = notification.systemType, urlFormatString = notification.urlFormatString, xSender = notification['x-sender'], application = notification.application, icon = notification.icon, extra = __rest(notification, ["id", "notificationId", "notificationType", "push", "system", "systemType", "urlFormatString", 'x-sender', "application", "icon"]);
            notifySystemNotificationReceived({
              id: id,
              type: systemType,
              extra: extra
            });

          case 15:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _handleServiceWorkerSystemNotificationReceived.apply(this, arguments);
}

function handleServiceWorkerUnknownNotificationReceived(_x17) {
  return _handleServiceWorkerUnknownNotificationReceived.apply(this, arguments);
}

function _handleServiceWorkerUnknownNotificationReceived() {
  _handleServiceWorkerUnknownNotificationReceived = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(event) {
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            notifyUnknownNotificationReceived(event.data.message);

          case 1:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _handleServiceWorkerUnknownNotificationReceived.apply(this, arguments);
}

function handleServiceWorkerUpdateInbox() {
  return _handleServiceWorkerUpdateInbox.apply(this, arguments);
}

function _handleServiceWorkerUpdateInbox() {
  _handleServiceWorkerUpdateInbox = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            // Notify the inbox to update itself.
            broadcastComponentEvent('notification_opened');

          case 1:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _handleServiceWorkerUpdateInbox.apply(this, arguments);
}

function getPushPermissionStatus() {
  var _a, _b;

  if (hasWebPushSupport()) {
    return Notification.permission;
  }

  var application = getApplication();

  if (hasSafariPushSupport() && window.safari && ((_b = (_a = application === null || application === void 0 ? void 0 : application.websitePushConfig) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.subject.UID)) {
    var _window$safari$pushNo = window.safari.pushNotification.permission(application.websitePushConfig.info.subject.UID),
        permission = _window$safari$pushNo.permission;

    return permission;
  }

  return 'default';
}

function getRemoteNotificationsEnabled() {
  var enabledStr = localStorage.getItem('re.notifica.push.remote_notifications_enabled');
  if (!enabledStr) return undefined;
  return enabledStr === 'true';
}

function setRemoteNotificationsEnabled(enabled) {
  if (enabled === undefined) {
    localStorage.removeItem('re.notifica.push.remote_notifications_enabled');
    return;
  }

  localStorage.setItem('re.notifica.push.remote_notifications_enabled', enabled.toString());
}

function retrieveAllowedUI() {
  var allowedUIStr = localStorage.getItem('re.notifica.push.allowed_ui');
  if (!allowedUIStr) return undefined;
  return allowedUIStr === 'true';
}

function storeAllowedUI(allowedUI) {
  if (!allowedUI) {
    localStorage.removeItem('re.notifica.push.allowed_ui');
    return;
  }

  localStorage.setItem('re.notifica.push.allowed_ui', allowedUI.toString());
}

function createDeniedBellIcon() {
  return new DOMParser().parseFromString("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><g fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" d=\"M11.955 0c.345 0 .672.048.976.138a7.772 7.772 0 0 0-1.42 1.624c-.815.202-1.327.97-1.357 2.002-.012.302-.174.441-.465.51-1.986.547-3.496 2.162-3.59 7.238-.104 2.265-.499 3.764-1.335 4.693-.604.674-1.301 1.36-1.51 1.696v.14h17.401v-.14c-.209-.337-.894-1.022-1.51-1.696-.515-.58-.862-1.382-1.076-2.455H18c.677 0 1.334-.087 1.96-.25.16.661.402 1.256.777 1.648.999 1.034 2.184 2.08 2.184 3.241 0 .848-.663 1.406-1.754 1.406h-4.903C16.171 22.048 14.417 24 11.954 24c-2.45 0-4.205-1.963-4.298-4.205H2.754C1.651 19.795 1 19.237 1 18.389c0-1.161 1.173-2.207 2.184-3.24.767-.802.976-2.452 1.069-3.788.081-4.577 1.266-7.527 4.356-8.643C8.992 1.197 10.247 0 11.955 0Zm2.497 19.795H9.47c.08 1.58 1.092 2.567 2.486 2.567 1.405 0 2.404-.987 2.497-2.567Z\"/><path d=\"M18 0a6 6 0 1 1 0 12 6 6 0 0 1 0-12Zm2.312 3.117L17.998 5.43 15.69 3.117a.41.41 0 0 0-.572 0 .41.41 0 0 0 0 .572L17.43 6l-2.313 2.313a.41.41 0 0 0 0 .572.41.41 0 0 0 .572 0L18 6.571l2.313 2.313a.404.404 0 0 0 .568-.572L18.57 5.998 20.88 3.69a.404.404 0 0 0-.568-.573Z\"/></g></svg>\n", 'image/svg+xml').firstChild;
}

function createGrantedBellIcon() {
  return new DOMParser().parseFromString("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><g fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" d=\"M11.955 0c.345 0 .672.048.976.138a7.772 7.772 0 0 0-1.42 1.624c-.815.202-1.327.97-1.357 2.002-.012.302-.174.441-.465.51-1.986.547-3.496 2.162-3.59 7.238-.104 2.265-.499 3.764-1.335 4.693-.604.674-1.301 1.36-1.51 1.696v.14h17.401v-.14c-.209-.337-.894-1.022-1.51-1.696-.515-.58-.862-1.382-1.076-2.455H18c.677 0 1.334-.087 1.96-.25.16.661.402 1.256.777 1.648.999 1.034 2.184 2.08 2.184 3.241 0 .848-.663 1.406-1.754 1.406h-4.903C16.171 22.048 14.417 24 11.954 24c-2.45 0-4.205-1.963-4.298-4.205H2.754C1.651 19.795 1 19.237 1 18.389c0-1.161 1.173-2.207 2.184-3.24.767-.802.976-2.452 1.069-3.788.081-4.577 1.266-7.527 4.356-8.643C8.992 1.197 10.247 0 11.955 0Zm2.497 19.795H9.47c.08 1.58 1.092 2.567 2.486 2.567 1.405 0 2.404-.987 2.497-2.567Z\"/><path d=\"M18 0a6 6 0 1 1 0 12 6 6 0 0 1 0-12Zm2.683 3c-.14 0-.216.046-.3.18l-3.126 5.023-1.623-2.142c-.087-.122-.174-.172-.3-.172-.198 0-.334.137-.334.33 0 .081.035.172.101.257l1.807 2.32c.105.137.213.204.362.204.15 0 .269-.067.352-.197l3.29-5.224A.479.479 0 0 0 21 3.32c0-.193-.125-.319-.317-.319Z\"/></g></svg>\n", 'image/svg+xml').firstChild;
}

function createBellIcon() {
  return new DOMParser().parseFromString("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path fill-rule=\"nonzero\" d=\"M1 18.39c0 .847.65 1.405 1.754 1.405h4.902C7.75 22.037 9.503 24 11.955 24c2.462 0 4.216-1.952 4.31-4.205h4.902c1.091 0 1.754-.558 1.754-1.406 0-1.161-1.185-2.207-2.184-3.24-.767-.802-.976-2.452-1.069-3.788-.081-4.577-1.266-7.527-4.356-8.643C14.917 1.197 13.674 0 11.955 0c-1.708 0-2.963 1.197-3.346 2.718-3.09 1.116-4.275 4.066-4.356 8.643-.093 1.336-.302 2.986-1.07 3.787C2.174 16.182 1 17.228 1 18.39Zm2.254-.35v-.139c.209-.337.906-1.022 1.51-1.696.836-.929 1.231-2.428 1.336-4.693.093-5.076 1.603-6.691 3.59-7.237.29-.07.452-.21.464-.511.035-1.208.732-2.056 1.8-2.056 1.08 0 1.766.848 1.813 2.056.011.302.162.441.453.51 1.998.547 3.508 2.162 3.601 7.238.104 2.265.5 3.764 1.324 4.693.616.674 1.301 1.36 1.51 1.696v.14H3.254Zm6.215 1.755h4.983c-.093 1.58-1.092 2.567-2.497 2.567-1.394 0-2.405-.987-2.486-2.567Z\"/></svg>\n", 'image/svg+xml').firstChild;
}

var ROOT_DOM_IDENTIFIER = 'notificare-push';

function createRootElement() {
  return createRoot(ROOT_DOM_IDENTIFIER);
}

function removeRootElement() {
  var root = document.getElementById(ROOT_DOM_IDENTIFIER);
  if (root) root.remove();
}

var permissionCheckTimer;

function showFloatingButton(_ref2) {
  var floatingButtonOptions = _ref2.options,
      onButtonClicked = _ref2.onButtonClicked;
  ensureCleanState$1();
  var root = createRootElement();
  root.classList.add('notificare-push-floating-button');
  var floatingButton = root.appendChild(document.createElement('div'));
  floatingButton.id = 'notificare-push-floating-button';
  floatingButton.setAttribute('data-permission-status', getPushPermissionStatus());
  floatingButton.classList.add('notificare__floating-button', FloatingButtonHorizontalAlignmentCssClasses[floatingButtonOptions.alignment.horizontal], FloatingButtonVerticalAlignmentCssClasses[floatingButtonOptions.alignment.vertical]);
  var iconContainer = floatingButton.appendChild(document.createElement('div'));
  iconContainer.classList.add('notificare__floating-button-icon-container');
  iconContainer.replaceChildren(createCurrentBellIconElement());
  var tooltip = document.createElement('span');
  tooltip.classList.add('notificare__floating-button-tooltip');
  tooltip.innerHTML = getCurrentTooltipText(floatingButtonOptions);
  floatingButton.appendChild(tooltip);
  floatingButton.addEventListener('click', function (e) {
    e.preventDefault();
    onButtonClicked();
  });
  permissionCheckTimer = window.setInterval(function () {
    return onPermissionStatusChanged(floatingButtonOptions);
  }, 2000); // Add the complete onboarding DOM to the page.

  document.body.appendChild(root);
}

function hideFloatingButton() {
  ensureCleanState$1();
}

function ensureCleanState$1() {
  removeRootElement();
  var timer = permissionCheckTimer;
  if (timer) window.clearInterval(timer);
  permissionCheckTimer = undefined;
}

function createCurrentBellIconElement() {
  var status = getPushPermissionStatus();
  var icon;

  switch (status) {
    case 'default':
      icon = createBellIcon();
      break;

    case 'granted':
      icon = createGrantedBellIcon();
      break;

    case 'denied':
      icon = createDeniedBellIcon();
      break;

    default:
      icon = createBellIcon();
  }

  icon.classList.add('notificare__floating-button-icon');
  return icon;
}

function getCurrentTooltipText(_ref3) {
  var permissionTexts = _ref3.permissionTexts;
  var status = getPushPermissionStatus();

  switch (status) {
    case 'default':
      return permissionTexts.default;

    case 'granted':
      return permissionTexts.granted;

    case 'denied':
      return permissionTexts.denied;

    default:
      return permissionTexts.default;
  }
}

function onPermissionStatusChanged(options) {
  var floatingButton = document.getElementById('notificare-push-floating-button');
  if (!floatingButton) return;
  var currentStatus = floatingButton.getAttribute('data-permission-status');
  var status = getPushPermissionStatus();
  if (status === currentStatus) return;
  var iconElements = floatingButton.getElementsByClassName('notificare__floating-button-icon-container');

  for (var i = 0; i < iconElements.length; i += 1) {
    var element = iconElements.item(i);
    if (element) element.replaceChildren(createCurrentBellIconElement());
  }

  var tooltipElements = floatingButton.getElementsByClassName('notificare__floating-button-tooltip');

  for (var _i = 0; _i < tooltipElements.length; _i += 1) {
    var _element = tooltipElements.item(_i);

    if (_element) _element.innerHTML = getCurrentTooltipText(options);
  }

  floatingButton.setAttribute('data-permission-status', status);
}

var FloatingButtonHorizontalAlignmentCssClasses = {
  start: 'notificare__floating-button__start',
  center: 'notificare__floating-button__horizontal-center',
  end: 'notificare__floating-button__end'
};
var FloatingButtonVerticalAlignmentCssClasses = {
  top: 'notificare__floating-button__top',
  center: 'notificare__floating-vertical-center',
  bottom: 'notificare__floating-button__bottom'
};

function createNotificareLogo() {
  return new DOMParser().parseFromString("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 16\"><g fill=\"none\" fill-rule=\"nonzero\"><path id=\"lettering\" fill=\"#000\" d=\"M24.34 9.811h1.894V5.76c.336-.257.798-.502 1.284-.502.261 0 .486.073.648.257.15.171.212.392.212.845V9.81h1.894V6.052c0-.869-.162-1.395-.536-1.787-.386-.392-.96-.612-1.608-.612-.772 0-1.42.318-1.894.698l-.025-.012v-.551h-1.87V9.81ZM33.326 6.8c0-.857.66-1.542 1.52-1.542s1.52.685 1.52 1.542-.66 1.543-1.52 1.543-1.52-.686-1.52-1.542Zm-1.895 0c0 1.776 1.458 3.147 3.415 3.147s3.415-1.371 3.415-3.147c0-1.775-1.458-3.146-3.415-3.146S31.431 5.024 31.431 6.8Zm9.01 2.547c.387.404.973.6 1.596.6.536 0 1.097-.147 1.384-.33V8.133c-.25.122-.599.245-.91.245-.573 0-.71-.44-.71-1.029V5.33h1.62V3.789H41.8V1.902l-1.895.319v1.567h-.997V5.33h.997v2.216c0 .955.212 1.457.536 1.8Zm3.964-7.468c0 .588.499 1.065 1.097 1.065s1.097-.477 1.097-1.065S46.1.813 45.502.813s-1.097.477-1.097 1.065Zm.15 7.933h1.894V3.788h-1.894V9.81Zm3.8 0h1.895v-4.48h1.421V3.788h-1.42V2.772c0-.514.124-.882.71-.882.212 0 .586.05.823.11V.495a3.085 3.085 0 0 0-1.048-.17c-.61 0-1.296.146-1.732.562-.474.441-.648 1.163-.648 2.008v.894h-.872V5.33h.872v4.481Zm4.201-7.933c0 .588.499 1.065 1.097 1.065s1.097-.477 1.097-1.065S54.25.813 53.653.813s-1.097.477-1.097 1.065Zm.15 7.933H54.6V3.788h-1.894V9.81Zm3.09-3c0 1.813 1.446 3.135 3.416 3.135.698 0 1.42-.147 2.006-.465V7.767c-.51.38-1.196.6-1.795.6-1.022 0-1.732-.65-1.732-1.567 0-.906.698-1.58 1.708-1.58.585 0 1.183.22 1.732.563V4.057a4.187 4.187 0 0 0-1.82-.404c-1.92 0-3.514 1.261-3.514 3.159Zm8.5 3.135c.698 0 1.31-.22 1.708-.502h.025c.336.343.822.477 1.32.477.362 0 .699-.073.91-.183V8.342a.725.725 0 0 1-.31.074c-.263 0-.375-.196-.375-.478V5.894c0-.76-.224-1.298-.685-1.665-.486-.392-1.222-.576-2.044-.576-.898 0-1.645.22-2.144.466v1.603c.486-.257 1.11-.477 1.795-.477.449 0 .773.098.947.257.137.122.237.343.237.637v.232a5.013 5.013 0 0 0-1.06-.11c-.635 0-1.246.11-1.72.429-.436.293-.747.795-.747 1.456 0 .625.274 1.102.723 1.408.398.27.897.392 1.42.392Zm.524-1.371c-.436 0-.785-.208-.785-.6 0-.465.486-.612.972-.612.2 0 .473.024.673.086v.881a1.723 1.723 0 0 1-.86.245Zm4.424 1.236h1.895V6.163c.448-.514.997-.71 1.657-.71.175 0 .362.024.511.061v-1.75a1.548 1.548 0 0 0-.399-.05c-.76 0-1.358.306-1.782.894l-.025-.012v-.808h-1.857V9.81ZM79.963 7.29c.025-.159.037-.428.037-.636 0-2.02-1.42-3-2.929-3-1.695 0-3.215 1.249-3.215 3.171 0 1.885 1.458 3.122 3.477 3.122.81 0 1.732-.184 2.33-.551V7.84c-.648.429-1.395.661-2.08.661-.873 0-1.571-.38-1.783-1.212h4.163Zm-2.917-2.216c.61 0 1.097.392 1.21 1.041h-2.469c.163-.685.674-1.04 1.26-1.04Z\"/><path id=\"leg\" fill=\"#10D1C4\" d=\"M12.076 12.399a6.05 6.05 0 0 0 1.568-.206L10.848 9.38l3.616 3.637a1.523 1.523 0 0 1 0 2.145 1.5 1.5 0 0 1-2.131 0l-2.747-2.764h2.49Z\"/><path id=\"leg-ring-background\" fill=\"#000\" d=\"m10.848 9.38 2.796 2.813a6.045 6.045 0 0 1-1.568.206h-2.49l-2.85-2.866a1.535 1.535 0 0 1-.132-.153h4.244Z\"/><path id=\"leg-overlay\" fill=\"#10D1C4\" d=\"m10.848 9.38 2.796 2.813a6.045 6.045 0 0 1-1.568.206h-2.49l-2.85-2.866a1.535 1.535 0 0 1-.132-.153h4.244Z\" opacity=\".6\"/><path id=\"ring\" fill=\"#000\" d=\"m12.184 12.398.058-.002.052-.001-.052.001c.036 0 .072-.002.108-.004l-.056.003.131-.006-.075.003.109-.005-.034.002.128-.009-.095.006c.075-.004.149-.01.223-.017l-.087.008.124-.012-.037.004.115-.013-.077.009.118-.014-.041.005c.035-.004.07-.008.106-.014l-.065.009.114-.015-.049.006c.107-.014.213-.032.319-.052l-.06.011.097-.018-.037.007.1-.02-.063.013.131-.028-.068.015.098-.021-.03.006.115-.026-.086.02a5.98 5.98 0 0 0 .226-.056L10.848 9.38H6.604c.04.053.085.104.133.153l2.849 2.866H6.038a6.038 6.038 0 0 1 0-12.076h6.038a6.038 6.038 0 0 1 1.568 11.87l-.015.004-.063.016.078-.02a5.993 5.993 0 0 1-1.46.205Zm-.108-9.056H6.038a3.02 3.02 0 0 0-.06 6.037h6.098a3.02 3.02 0 0 0 0-6.037Z\"/></g></svg>\n", 'image/svg+xml').firstChild;
}

function showOnboarding(_ref4) {
  var application = _ref4.application,
      autoOnboardingOptions = _ref4.autoOnboardingOptions,
      onAcceptClicked = _ref4.onAcceptClicked,
      onCancelClicked = _ref4.onCancelClicked;

  var _a;

  var options = getOptions();
  if (!options) return;
  ensureCleanState();
  var root = createRootElement();
  root.classList.add('notificare-push-onboarding');
  root.appendChild(createBackdrop(function () {}));
  var modal = root.appendChild(createModal({
    alignment: 'top'
  }));
  modal.classList.add('notificare__onboarding-modal');
  var content = modal.appendChild(createModalContent());
  content.classList.add('notificare__onboarding-content');

  if ((_a = application.websitePushConfig) === null || _a === void 0 ? void 0 : _a.icon) {
    var icon = content.appendChild(document.createElement('img'));
    icon.classList.add('notificare__onboarding-icon');
    icon.setAttribute('src', "".concat(options.services.awsStorageHost).concat(application.websitePushConfig.icon));
  }

  var textContent = content.appendChild(document.createElement('div'));
  textContent.classList.add('notificare__onboarding-text-content');
  var title = textContent.appendChild(document.createElement('p'));
  title.classList.add('notificare__onboarding-title');
  title.innerHTML = application.name;
  var text = textContent.appendChild(document.createElement('p'));
  text.classList.add('notificare__onboarding-text');
  text.innerHTML = autoOnboardingOptions.message;
  var footer = modal.appendChild(createModalFooter());
  footer.classList.add('notificare__onboarding-footer');

  if (application.branding) {
    var brandingContainer = footer.appendChild(document.createElement('a'));
    brandingContainer.classList.add('notificare__onboarding-branding-content');
    brandingContainer.setAttribute('href', 'https://notificare.com');
    brandingContainer.setAttribute('target', '_blank');
    var brandingText = brandingContainer.appendChild(document.createElement('p'));
    brandingText.classList.add('notificare__onboarding-branding');
    brandingText.innerHTML = 'powered by';
    var brandingLogo = brandingContainer.appendChild(createNotificareLogo());
    brandingLogo.classList.add('notificare__onboarding-branding-logo');
  }

  var footerButtons = footer.appendChild(document.createElement('div'));
  footerButtons.classList.add('notificare__onboarding-actions');
  var cancelButton = footerButtons.appendChild(createDestructiveButton({
    text: autoOnboardingOptions.cancelButton,
    onClick: function onClick() {
      ensureCleanState();
      onCancelClicked();
    }
  }));
  cancelButton.classList.add('notificare__onboarding-cancel-button');
  var acceptButton = footerButtons.appendChild(createPrimaryButton({
    text: autoOnboardingOptions.acceptButton,
    onClick: function onClick() {
      ensureCleanState();
      onAcceptClicked();
    }
  }));
  acceptButton.classList.add('notificare__onboarding-accept-button'); // Add the complete onboarding DOM to the page.

  document.body.appendChild(root);
}

function hideOnboarding() {
  ensureCleanState();
}

function ensureCleanState() {
  removeRootElement();
}

function transaction(_x18) {
  return _transaction.apply(this, arguments);
}

function _transaction() {
  _transaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(_ref5) {
    var originalValue, restoreValue, fn;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            originalValue = _ref5.originalValue, restoreValue = _ref5.restoreValue, fn = _ref5.fn;
            _context24.prev = 1;
            _context24.next = 4;
            return fn();

          case 4:
            return _context24.abrupt("return", _context24.sent);

          case 7:
            _context24.prev = 7;
            _context24.t0 = _context24["catch"](1);
            restoreValue(originalValue);
            throw _context24.t0;

          case 11:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24, null, [[1, 7]]);
  }));
  return _transaction.apply(this, arguments);
}

var ongoingPushRegistration = false;

function hasWebPushCapabilities() {
  return hasWebPushSupport() || hasSafariPushSupport();
}

function enableRemoteNotifications$1() {
  return _enableRemoteNotifications$.apply(this, arguments);
}

function _enableRemoteNotifications$() {
  _enableRemoteNotifications$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
    var _a, options, application, token, _token;

    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            options = getOptions();

            if (options) {
              _context25.next = 3;
              break;
            }

            throw new NotificareNotConfiguredError();

          case 3:
            application = getApplication();

            if (application) {
              _context25.next = 6;
              break;
            }

            throw new NotificareNotReadyError();

          case 6:
            if ((_a = application.websitePushConfig) === null || _a === void 0 ? void 0 : _a.icon) {
              _context25.next = 8;
              break;
            }

            throw new Error('Missing application icon. Please check your Website Push configurations in our dashboard before proceeding.');

          case 8:
            if (!(application.websitePushConfig.allowedDomains.indexOf(options.applicationHost) === -1)) {
              _context25.next = 10;
              break;
            }

            throw new Error('Missing allowed domain. Please check your Website Push configurations in our dashboard before proceeding.');

          case 10:
            if (!(!hasWebPushSupport() && !hasSafariPushSupport())) {
              _context25.next = 12;
              break;
            }

            throw new Error('Your browser does not support Service Workers nor Safari Website Push.');

          case 12:
            if (!ongoingPushRegistration) {
              _context25.next = 14;
              break;
            }

            throw new Error('Cannot process multiple registration at the same time.');

          case 14:
            setRemoteNotificationsEnabled(true);
            _context25.prev = 15;
            ongoingPushRegistration = true;

            if (!hasWebPushSupport()) {
              _context25.next = 33;
              break;
            }

            _context25.next = 20;
            return enableWebPushNotifications(application, options);

          case 20:
            token = _context25.sent;
            _context25.next = 23;
            return registerPushDevice({
              transport: 'WebPush',
              token: token.endpoint,
              keys: token.keys
            });

          case 23:
            _context25.prev = 23;
            _context25.next = 26;
            return postMessageToServiceWorker({
              action: 're.notifica.ready'
            });

          case 26:
            _context25.next = 31;
            break;

          case 28:
            _context25.prev = 28;
            _context25.t0 = _context25["catch"](23);
            logger.warning('Failed to send a message to the service worker.', _context25.t0);

          case 31:
            _context25.next = 39;
            break;

          case 33:
            if (!hasSafariPushSupport()) {
              _context25.next = 39;
              break;
            }

            _context25.next = 36;
            return enableSafariPushNotifications();

          case 36:
            _token = _context25.sent;
            _context25.next = 39;
            return registerPushDevice({
              transport: 'WebsitePush',
              token: _token
            });

          case 39:
            _context25.prev = 39;
            ongoingPushRegistration = false;
            return _context25.finish(39);

          case 42:
            _context25.prev = 42;
            _context25.next = 45;
            return updateNotificationSettings();

          case 45:
            _context25.next = 50;
            break;

          case 47:
            _context25.prev = 47;
            _context25.t1 = _context25["catch"](42);
            logger.warning('Unable to update the notification settings.', _context25.t1);

          case 50:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25, null, [[15,, 39, 42], [23, 28], [42, 47]]);
  }));
  return _enableRemoteNotifications$.apply(this, arguments);
}

function disableRemoteNotifications$1() {
  return _disableRemoteNotifications$.apply(this, arguments);
}

function _disableRemoteNotifications$() {
  _disableRemoteNotifications$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
    var device;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            device = getCurrentDevice();

            if (device) {
              _context27.next = 3;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 3:
            _context27.next = 5;
            return transaction({
              originalValue: getRemoteNotificationsEnabled(),
              restoreValue: setRemoteNotificationsEnabled,
              fn: function () {
                var _fn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
                  var options;
                  return _regeneratorRuntime.wrap(function _callee26$(_context26) {
                    while (1) {
                      switch (_context26.prev = _context26.next) {
                        case 0:
                          setRemoteNotificationsEnabled(false);

                          if (!(device.transport === 'WebPush')) {
                            _context26.next = 4;
                            break;
                          }

                          _context26.next = 4;
                          return disableWebPushNotifications();

                        case 4:
                          options = getOptions();

                          if (!(options === null || options === void 0 ? void 0 : options.ignoreTemporaryDevices)) {
                            _context26.next = 10;
                            break;
                          }

                          _context26.next = 8;
                          return deleteDevice();

                        case 8:
                          _context26.next = 12;
                          break;

                        case 10:
                          _context26.next = 12;
                          return registerTemporaryDevice();

                        case 12:
                          storeAllowedUI(false);
                          notifyNotificationSettingsChanged(false);

                        case 14:
                        case "end":
                          return _context26.stop();
                      }
                    }
                  }, _callee26);
                }));

                function fn() {
                  return _fn.apply(this, arguments);
                }

                return fn;
              }()
            });

          case 5:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));
  return _disableRemoteNotifications$.apply(this, arguments);
}

function handleAutoOnboarding(_x19, _x20) {
  return _handleAutoOnboarding.apply(this, arguments);
}

function _handleAutoOnboarding() {
  _handleAutoOnboarding = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(application, autoOnboardingOptions) {
    var _a, permission, device, retryAfterMillis, lastAttemptMillis, canShowOnboarding;

    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            permission = getPushPermissionStatus();

            if (!(permission === 'denied')) {
              _context28.next = 4;
              break;
            }

            logger.info('The user denied remote notifications.');
            return _context28.abrupt("return");

          case 4:
            device = getCurrentDevice();

            if (!(device && device.transport !== 'Notificare' && permission === 'granted')) {
              _context28.next = 7;
              break;
            }

            return _context28.abrupt("return");

          case 7:
            retryAfterMillis = ((_a = autoOnboardingOptions.retryAfterHours) !== null && _a !== void 0 ? _a : 24) * 60 * 60 * 1000;
            lastAttemptMillis = getOnboardingLastAttempt();
            canShowOnboarding = !lastAttemptMillis || lastAttemptMillis + retryAfterMillis < Date.now();

            if (canShowOnboarding) {
              _context28.next = 12;
              break;
            }

            return _context28.abrupt("return");

          case 12:
            if (!autoOnboardingOptions.showAfterSeconds) {
              _context28.next = 15;
              break;
            }

            _context28.next = 15;
            return sleep(autoOnboardingOptions.showAfterSeconds * 1000);

          case 15:
            showOnboarding({
              application: application,
              autoOnboardingOptions: autoOnboardingOptions,
              onAcceptClicked: function onAcceptClicked() {
                localStorage.setItem('re.notifica.push.onboarding_last_attempt', Date.now().toString());
                enableRemoteNotifications$1().then(function () {
                  return logger.debug('Remote notifications enabled.');
                }).catch(function (e) {
                  return logger.error("Failed to enable remote notifications: ".concat(e));
                });
              },
              onCancelClicked: function onCancelClicked() {
                localStorage.setItem('re.notifica.push.onboarding_last_attempt', Date.now().toString());
              }
            });

          case 16:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));
  return _handleAutoOnboarding.apply(this, arguments);
}

function handleFloatingButton(_x21, _x22) {
  return _handleFloatingButton.apply(this, arguments);
}

function _handleFloatingButton() {
  _handleFloatingButton = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(application, options) {
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            showFloatingButton({
              options: options,
              onButtonClicked: function onButtonClicked() {
                if (getPushPermissionStatus() === 'granted') return;
                enableRemoteNotifications$1().then(function () {
                  return logger.debug('Remote notifications enabled.');
                }).catch(function (e) {
                  return logger.error("Failed to enable remote notifications: ".concat(e));
                });
              }
            });

          case 1:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));
  return _handleFloatingButton.apply(this, arguments);
}

function getOnboardingLastAttempt() {
  var lastAttemptStr = localStorage.getItem('re.notifica.push.onboarding_last_attempt');
  if (!lastAttemptStr) return undefined;
  return parseInt(lastAttemptStr, 10);
}

function updateNotificationSettings() {
  return _updateNotificationSettings.apply(this, arguments);
}

function _updateNotificationSettings() {
  _updateNotificationSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
    var device, granted, allowedUI, firstRegistrationStr, firstRegistration;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            if (isConfigured()) {
              _context30.next = 2;
              break;
            }

            throw new NotificareNotConfiguredError();

          case 2:
            device = getCurrentDevice();

            if (device) {
              _context30.next = 5;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 5:
            granted = getPushPermissionStatus() === 'granted';
            allowedUI = device.transport !== 'Notificare' && granted;

            if (!(retrieveAllowedUI() !== allowedUI)) {
              _context30.next = 15;
              break;
            }

            _context30.next = 10;
            return updateCloudDevice({
              environment: getCloudApiEnvironment(),
              deviceId: device.id,
              payload: {
                allowedUI: allowedUI,
                webPushCapable: hasWebPushCapabilities()
              }
            });

          case 10:
            storeAllowedUI(allowedUI);
            notifyNotificationSettingsChanged(allowedUI);
            logger.debug('User notification settings updated.');
            _context30.next = 16;
            break;

          case 15:
            logger.debug('User notification settings update skipped, nothing changed.');

          case 16:
            firstRegistrationStr = localStorage.getItem('re.notifica.push.first_registration');
            firstRegistration = firstRegistrationStr == null || firstRegistrationStr === 'true';

            if (!(allowedUI && firstRegistration)) {
              _context30.next = 22;
              break;
            }

            _context30.next = 21;
            return logPushRegistration();

          case 21:
            localStorage.setItem('re.notifica.push.first_registration', 'false');

          case 22:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30);
  }));
  return _updateNotificationSettings.apply(this, arguments);
}

function monitorPushPermissionChanges() {
  return _monitorPushPermissionChanges.apply(this, arguments);
}
/* eslint-disable class-methods-use-this */


function _monitorPushPermissionChanges() {
  _monitorPushPermissionChanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
    var permissionStatus;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            if ('permissions' in navigator) {
              _context31.next = 2;
              break;
            }

            throw new Error('The current browser does not supporting the permission status.');

          case 2:
            _context31.next = 4;
            return navigator.permissions.query({
              name: 'notifications'
            });

          case 4:
            permissionStatus = _context31.sent;

            permissionStatus.onchange = function () {
              if (!getRemoteNotificationsEnabled() || ongoingPushRegistration) return;
              var device = getCurrentDevice();
              var hasPushPermission = getPushPermissionStatus() === 'granted';
              var canRegisterPushDevice = !device || device.transport === 'Notificare';

              if (hasPushPermission && canRegisterPushDevice) {
                logger.debug('Enabling remote notifications due to a permission status change.');
                enableRemoteNotifications$1().catch(function (e) {
                  return logger.warning('Failed to enable remote notifications.', e);
                });
                return;
              }

              logger.debug('Updating notification settings due to a permission status change.');
              updateNotificationSettings().catch(function (e) {
                return logger.warning('Unable to update the notification settings.', e);
              });
            };

          case 6:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31);
  }));
  return _monitorPushPermissionChanges.apply(this, arguments);
}

var PushComponent = /*#__PURE__*/function (_Component) {
  _inherits(PushComponent, _Component);

  var _super = _createSuper(PushComponent);

  function PushComponent() {
    _classCallCheck(this, PushComponent);

    return _super.call(this, 'push');
  }

  _createClass(PushComponent, [{
    key: "migrate",
    value: function migrate() {
      var lastAttemptStr = localStorage.getItem('notificareOnboardingLastAttempt');

      if (lastAttemptStr) {
        var lastAttempt = parseInt(lastAttemptStr, 10);

        if (!Number.isNaN(lastAttempt)) {
          localStorage.setItem('re.notifica.push.onboarding_last_attempt', lastAttempt.toString());
        }
      }

      var deviceStr = localStorage.getItem('notificareDevice');

      if (deviceStr) {
        try {
          var device = JSON.parse(deviceStr);

          if (device.transport !== 'Notificare' || device.allowedUI) {
            setRemoteNotificationsEnabled(true);
          }

          if (device.allowedUI) {
            localStorage.setItem('re.notifica.push.first_registration', 'false');
          }
        } catch (e) {
          logger.error('Unable to decode the legacy device.', e);
        }
      }

      localStorage.removeItem('notificareOnboardingLastAttempt');
    }
  }, {
    key: "configure",
    value: function configure() {
      if (hasWebPushSupport()) {
        navigator.serviceWorker.onmessage = handleServiceWorkerMessage;
      }

      monitorPushPermissionChanges().then(function () {
        return logger.debug('Started monitoring push permission changes.');
      }).catch(function (error) {
        return logger.error('Unable to monitor push permission changes.', error);
      });
    }
  }, {
    key: "launch",
    value: function () {
      var _launch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(getRemoteNotificationsEnabled() !== false && getPushPermissionStatus() === 'granted')) {
                  _context.next = 10;
                  break;
                }

                _context.prev = 1;
                logger.debug('Automatically enabling remote notifications.');
                _context.next = 5;
                return enableRemoteNotifications$1();

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                logger.error('Failed to automatically enable remote notifications.', _context.t0);

              case 10:
                this.handleSafariWebPushNotification();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 7]]);
      }));

      function launch() {
        return _launch.apply(this, arguments);
      }

      return launch;
    }()
  }, {
    key: "unlaunch",
    value: function () {
      var _unlaunch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var device;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.removeOnboardingElements();
                localStorage.removeItem('re.notifica.push.first_registration');
                localStorage.removeItem('re.notifica.push.onboarding_last_attempt'); // // Update the local notification settings.
                // // Registering a temporary device automatically reports the allowedUI to the API.
                // allowedUI = false

                device = getCurrentDevice();

                if (!(device && device.transport === 'WebPush')) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 7;
                return disableWebPushNotifications();

              case 7:
                setRemoteNotificationsEnabled(undefined);
                storeAllowedUI(undefined);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function unlaunch() {
        return _unlaunch.apply(this, arguments);
      }

      return unlaunch;
    }()
  }, {
    key: "postLaunch",
    value: function () {
      var _postLaunch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.handleOnboarding();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function postLaunch() {
        return _postLaunch.apply(this, arguments);
      }

      return postLaunch;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "executeCommand",
    value: function () {
      var _executeCommand = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(command, data) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(command === 'hasWebPushSupport')) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", hasWebPushSupport());

              case 2:
                throw new Error("Unsupported command '".concat(command, "' in '").concat(this.name, "' component."));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function executeCommand(_x23, _x24) {
        return _executeCommand.apply(this, arguments);
      }

      return executeCommand;
    }()
  }, {
    key: "handleOnboarding",
    value: function handleOnboarding() {
      var _a;

      var application = getApplication();
      if (!((_a = application === null || application === void 0 ? void 0 : application.websitePushConfig) === null || _a === void 0 ? void 0 : _a.launchConfig)) return;

      if (!hasWebPushCapabilities()) {
        logger.info('The browser does not support remote notifications.');
        return;
      }

      var autoOnboardingOptions = application.websitePushConfig.launchConfig.autoOnboardingOptions;

      if (autoOnboardingOptions) {
        logger.debug('Handling the automatic onboarding.');
        handleAutoOnboarding(application, autoOnboardingOptions).catch(function (error) {
          return logger.error("Failed to handle the automatic onboarding: ".concat(error));
        });
        return;
      }

      var floatingButtonOptions = application.websitePushConfig.launchConfig.floatingButtonOptions;

      if (floatingButtonOptions) {
        logger.debug('Handling the floating button.');
        handleFloatingButton(application, floatingButtonOptions).catch(function (error) {
          return logger.error("Failed to handle the floating button: ".concat(error));
        });
      }
    }
  }, {
    key: "handleSafariWebPushNotification",
    value: function handleSafariWebPushNotification() {
      var _a, _b; // Do nothing when running in Web Push mode.


      if (hasWebPushSupport()) return;
      var application = getApplication();
      if (!application) return;
      var urlFormatString = (_a = application.websitePushConfig) === null || _a === void 0 ? void 0 : _a.urlFormatString;
      if (!urlFormatString) return;
      var notificationId = (_b = this.checkSafariWebPushNotification(urlFormatString)) !== null && _b !== void 0 ? _b : this.checkSafariWebPushNotificationFallback(urlFormatString);
      if (!notificationId) return;
      this.handleSafariNotificationOpened(notificationId).catch(function (error) {
        return logger.error("Unable to handle the notification open: ".concat(error));
      });
    }
  }, {
    key: "checkSafariWebPushNotification",
    value: function checkSafariWebPushNotification(urlFormatString) {
      // Exact match between URLFormatString and current window.location
      var regex = new RegExp(urlFormatString.replace(/([.*+?^${}()|[\]/\\])/g, '\\$1').replace('%@', '(\\w+)'));
      var components = regex.exec(window.location.toString());
      if (!components || components.length < 2) return undefined;
      return components[1];
    }
  }, {
    key: "checkSafariWebPushNotificationFallback",
    value: function checkSafariWebPushNotificationFallback(urlFormatString) {
      // Fallback to match by query param
      var templateSearchParameters = new URL(urlFormatString).searchParams;
      var locationSearchParameters = new URLSearchParams(window.location.search);
      var notificationSearchParameter; // eslint-disable-next-line no-restricted-syntax

      var _iterator = _createForOfIteratorHelper(templateSearchParameters.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (value === '%@') {
            notificationSearchParameter = key;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!notificationSearchParameter || !locationSearchParameters.has(notificationSearchParameter)) {
        return undefined;
      }

      var notificationId = locationSearchParameters.get(notificationSearchParameter);
      if (!notificationId) return undefined;
      return notificationId;
    }
  }, {
    key: "handleSafariNotificationOpened",
    value: function () {
      var _handleSafariNotificationOpened = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(notificationId) {
        var notification;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return logNotificationOpen(notificationId);

              case 2:
                _context5.next = 4;
                return logNotificationInfluenced(notificationId);

              case 4:
                // Notify the inbox to update itself.
                broadcastComponentEvent('notification_opened');
                _context5.next = 7;
                return fetchNotification(notificationId);

              case 7:
                notification = _context5.sent;
                notifyNotificationOpened(notification);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function handleSafariNotificationOpened(_x25) {
        return _handleSafariNotificationOpened.apply(this, arguments);
      }

      return handleSafariNotificationOpened;
    }()
  }, {
    key: "removeOnboardingElements",
    value: function removeOnboardingElements() {
      hideOnboarding();
      hideFloatingButton();
    }
  }]);

  return PushComponent;
}(Component);

function registerComponents() {
  registerComponent(new PushComponent());
}

function hasRemoteNotificationsEnabled() {
  var _a;

  return (_a = getRemoteNotificationsEnabled()) !== null && _a !== void 0 ? _a : false;
}

function getAllowedUI() {
  var _a;

  return (_a = retrieveAllowedUI()) !== null && _a !== void 0 ? _a : false;
}

function enableRemoteNotifications() {
  return _enableRemoteNotifications.apply(this, arguments);
}

function _enableRemoteNotifications() {
  _enableRemoteNotifications = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            checkPrerequisites();
            _context32.next = 3;
            return enableRemoteNotifications$1();

          case 3:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32);
  }));
  return _enableRemoteNotifications.apply(this, arguments);
}

function disableRemoteNotifications() {
  return _disableRemoteNotifications.apply(this, arguments);
}

function _disableRemoteNotifications() {
  _disableRemoteNotifications = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            checkPrerequisites();
            _context33.next = 3;
            return disableRemoteNotifications$1();

          case 3:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33);
  }));
  return _disableRemoteNotifications.apply(this, arguments);
}

function checkPrerequisites() {
  if (!isReady()) {
    logger.warning('Notificare is not ready yet.');
    throw new NotificareNotReadyError();
  }

  var application = getApplication();

  if (!application) {
    logger.warning('Notificare application is not yet available.');
    throw new NotificareApplicationUnavailableError();
  }

  if (!application.services.websitePush) {
    logger.warning('Notificare website push functionality is not enabled.');
    throw new NotificareServiceUnavailableError('websitePush');
  }
}

registerComponents();
export { disableRemoteNotifications, enableRemoteNotifications, getAllowedUI, getPushPermissionStatus, hasRemoteNotificationsEnabled, hasWebPushCapabilities, onNotificationActionOpened, onNotificationOpened, onNotificationReceived, onNotificationSettingsChanged, onSystemNotificationReceived, onUnknownNotificationReceived };